<template>
  <div class="container">
    
    <div v-if="!EstadoBotonUsuarios" class="row mt-5">
      <div class="col-12 col-sm-4" v-if="usuAuxiliar != 0">
        <div>
          <img
            src="../../assets/ActividadRealizar/postulacion.png"
            alt=""
            class="border rounded p-1 img-hover3 w-100"
            @click="EstadoBotonPostulacion(true)"
          />
        </div>
      </div>

      <div class="col-12 col-sm-4">
        <div>
          <img
            src="../../assets/ActividadRealizar/personal.png"
            alt=""
            class="border rounded p-1 img-hover w-100"
            @click="EstadoPersonal({ estado: true, estadoPostulacion: 1 })"
          />
        </div>
      </div>

      <div class="col-12 col-sm-4">
        <div>
          <img
            src="../../assets/ActividadRealizar/procesos.png"
            alt=""
            class="border rounded p-1 img-hover2 w-100"
            @click="EstadoOperacional(true)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "CopiasPerfilUsuario",
  data() {
    return {
      permisoVisualizador: "",
      trabacceso: "",
      usuAuxiliar: "",
    };
  },
  mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");
    this.usuAuxiliar = localStorage.getItem("usuAuxiliar");
    this.trabacceso = localStorage.getItem("trabacceso");
  },
  methods: {
    ...mapActions("acciones", [
      "EstadoPersonal",
      "EstadoOperacional",
      "EstadoBotonPostulacion",
    ]),
  },
  computed: { ...mapGetters("acciones", ["EstadoBotonUsuarios"]) },
};
</script>

<style scoped>
.img-hover {
  cursor: pointer; /* 👈 Hace que salga la manito */
  transition: transform 0.6s ease;
   box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2); /* 👈 Hace la animación suave */
}

.img-hover:hover {
  transform: scale(1.15); /* 👈 Agranda la imagen un 10% al pasar el mouse */
}

.img-hover2 {
  cursor: pointer; /* 👈 Hace que salga la manito */
  transition: transform 0.6s ease; 
   text-transform: uppercase;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);/* 👈 Hace la animación suave */
}

.img-hover2:hover {
  transform: scale(1.15);
  /* 👈 Agranda la imagen un 10% al pasar el mouse */
}

.img-hover3 {
  cursor: pointer; /* 👈 Hace que salga la manito */
  transition: transform 0.6s ease;

   box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2); /* 👈 Hace la animación suave */
}

.img-hover3:hover {
  transform: scale(1.15); 
   /* 👈 Agranda la imagen un 10% al pasar el mouse */
}
</style>
